import { forwardRef, type ForwardedRef, type ReactElement } from 'react';

type ForwardRefRenderFunction<P, R> = (
  props: P,
  ref: ForwardedRef<R>,
) => ReactElement;

/**
 * `React.forwardRef` erases call-signature generics the same way `memo` does.
 * This is an explicit typing of `forwardRef` (runtime unchanged) so generic
 * components stay generic while still accepting a `ref`.
 *
 * @see typedMemo
 */
export const typedForwardRef = forwardRef as <P, R>(
  render: ForwardRefRenderFunction<P, R>,
) => (props: P & { ref?: ForwardedRef<R> }) => ReactElement;
